export default __webpack_public_path__ + "static/media/7(Royal-Tulip-Sea-Pearl-Beach-Resorts-&-Spa-Ltd).9551f3e1.jpg";